import { useState } from "react";
import { Link, matchPath, useLocation } from "react-router";
import { useTranslate } from "ra-core";
import {
  Handshake, Home, ListTodo, Menu,
  ScrollText, Settings, Users, CreditCard,
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger, SheetClose } from "@/components/ui/sheet";
import { cn } from "@/lib/utils";

const NAV_ITEMS = [
  { href: "/",          icon: Home,       labelKey: "ra.page.dashboard",        args: undefined },
  { href: "/contacts",  icon: Users,      labelKey: "resources.contacts.name",  args: { smart_count: 2 } },
  { href: "/companies", icon: Users,      labelKey: "resources.companies.name", args: { smart_count: 2 } },
  { href: "/deals",     icon: Handshake,  labelKey: "resources.deals.name",     args: { smart_count: 2 } },
  { href: "/contracts", icon: ScrollText, labelKey: "resources.contracts.name", args: { smart_count: 2 } },
  { href: "/payments",  icon: CreditCard, labelKey: "resources.payments.name",  args: { smart_count: 2 } },
  { href: "/tasks",     icon: ListTodo,   labelKey: "resources.tasks.name",     args: { smart_count: 2 } },
  { href: "/settings",  icon: Settings,   labelKey: "crm.settings.title",       args: undefined },
];

const MobileHeader = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const translate = useTranslate();

  return (
    <header className="fixed top-0 left-0 right-0 z-10 bg-secondary h-14 px-2 w-full flex items-center gap-2">
      <Sheet>
        <SheetTrigger asChild>
          <Button variant="ghost" size="icon" aria-label="Меню" className="shrink-0">
            <Menu className="h-5 w-5" />
          </Button>
        </SheetTrigger>
        <SheetContent side="left" className="w-72 p-0 flex flex-col">
          <nav className="flex flex-col gap-1 p-3 flex-1 overflow-y-auto mt-10">
            {NAV_ITEMS.map(({ href, icon: Icon, labelKey, args }) => {
              const isActive = href === "/"
                ? location.pathname === "/"
                : !!matchPath(href + "/*", location.pathname);
              return (
                <SheetClose asChild key={href}>
                  <Link
                    to={href}
                    className={cn(
                      "flex items-center gap-3 px-3 py-3 rounded-lg text-sm font-medium transition-colors",
                      isActive
                        ? "bg-primary text-primary-foreground"
                        : "text-foreground hover:bg-accent"
                    )}
                  >
                    <Icon className="h-5 w-5 shrink-0" />
                    {translate(labelKey, args ?? {})}
                  </Link>
                </SheetClose>
              );
            })}
          </nav>
        </SheetContent>
      </Sheet>

      <div className="flex flex-1 items-center justify-between">
        {children}
      </div>
    </header>
  );
};

export default MobileHeader;
